import { AnnotationTool } from "substance";

class RomanTool extends AnnotationTool {}

export default RomanTool;
